import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTopCustomerReport extends Layout {
    etCategories: ExcludableTextbox;
    etCustomers: ExcludableTextbox;
    sourceTopCustomerReport: DataSource;
    switchCompare: Switch;
    switchFuelSurcharge: Switch;
    switchMonthlyTotals: Switch;
    switchOtherCharges: Switch;
    switchRollUp: Switch;
    textboxDateOne: Textbox;
    textboxDateTwo: Textbox;
    textboxDateType: Textbox;
    textboxNumCustomers: Textbox;
    textboxSortBy: Textbox;
}
